<!-- import app-success -->
<app-success
    titleBtn="التالي" 
    *ngIf="alertSuccess"
    (Submit)="alertSubmit()"
    [msg]="'تم ارسال البيانات وسوف يتم تاكيد الحجز بعد الدفع'"
>
</app-success>

<!-- import app-terms-and-conditions -->
<app-terms-and-conditions 
    *ngIf="showTerms"
    (close)="showTerms = $event"
    [type]="PAYMENT_TERMS_TYPE.booking"
    termsTitle="الشروط والاحكام الخاصه بالحجوزات"
>
</app-terms-and-conditions>

<!-- // import app-payment -->
<app-payment-response [callback]="paymentCallback.bind(this)"></app-payment-response>
<app-payment 
    *ngIf="openPayment"
    [metadata]="metaData"
    [soldItemInfo]="this.infoAds"
    [type]="payment_type.booking"
    [redirect]="'realty-management/bookings-realty/' + Id"
>
</app-payment>


<div class="bookings">
    <!-- import app-second-header -->
    <app-second-header>
        <!-- // start send as content projection -->
        <div class="wrap_navigate">
            <!-- import app-navigation -->
            <app-navigation [navigate]="navigation" [style]="{top: '60px'}"></app-navigation>
        </div>
        <!-- // end send as content projection -->
    </app-second-header> 
    <div class="custom_container">
        <div class="wrap_info_realty">
            <app-advertisement-card [info]="infoAds" />
        </div>
    
        <div class="wrap_othere_details">
            <form [formGroup]="FormBooking" (ngSubmit)="submit()">
                <div class="row w-100">
                    <!-- import ng-select  -->
                    <div class="col-12">
                        <app-label title="المدة"></app-label>
                        <div class="wrap_box">
                            <ng-select 
                                bindValue="id"
                                bindLabel="name"
                                class="text-center"
                                [clearable]="false"
                                [searchable]="false"
                                [items]="listOfRentType"
                                placeholder="نوع الحجز"
                                formControlName="durationType"
                                notFoundText="لا يوجد انواع حجز متاحة!"
                            >
                            </ng-select>
                        </div>
                    </div>
                </div>

                <!-- import ngb-datepicker  -->
                <ngb-datepicker 
                    #dp
                    [weekdays]="false"
                    [dayTemplate]="t"
                    navigation="none"
                    [displayMonths]="1" 
                    [minDate]="minDate"
                    outsideDays="hidden"
                    [markDisabled]="isDisabled"
                    (dateSelect)="onDateSelection($event)"
                >
                    <ng-template #t let-date let-focused="focused">
                      <span class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                            [class.faded]="isHovered(date) || isInside(date)"
                        >
                        {{ date.day }}
                        <br>
                        {{getDay(date)}}
                    </span>
                    </ng-template>
                    <ng-template ngbDatepickerContent>
                        <div *ngFor="let month of dp.state.months">
                            <ngb-datepicker-month [month]="month"></ngb-datepicker-month>
                            <div class="carousel_month border_r text-center">
                                <span class="arrow right float-start effect" (click)="navigate(-1)">
                                    <img src="/assets/img/arrow_right.svg" />
                                </span>
                                <span class="month_text">{{ getMonth(month) }}</span>
                                <span class="arrow left float-end effect" (click)="navigate(1)">
                                    <img src="/assets/img/arrow.svg" />
                                </span>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                      </ng-template>
                </ngb-datepicker>
                <!-- import app-validation-input -->
                <div class="wrap_validation text-center">
                    <app-validation-input
                        class="ms-0"
                        text="يجب تحديد تاريخ بداية و نهاية بدون ايام محجوزه بينهم"
                        *ngIf="FormBooking?.errors?.rangeNotValid && FormBooking?.touched"
                    >
                    </app-validation-input>
                </div>

                <!-- import app-available-paument-methods -->
                <app-available-paument-methods [class]="'color_black'"></app-available-paument-methods>
    
                <!-- start bill -->
                <ng-container *ngIf="billInfo">
                    <app-bill-data title="رسوم الحجز"[billInfo]="billInfo" />
                </ng-container>
                <!-- end bill -->

                <div class="wrap_check mt-4">
                    <!-- import app-input-check  -->
                    <app-input-check name="acceptTerms" (checkChange)="acceptTerms = $event; showTerms = $event" ></app-input-check>
    
                    <!-- import app-label -->
                    <app-label 
                        for="acceptTerms"
                        class="float-start"
                        title="قراءة الشروط" 
                    >
                    </app-label>

                    <a 
                        routerLink="./" 
                        (click)="showTerms = true"
                        class="label_lg_normal float-end main_color"
                    >
                        صفحة الشروط
                    </a>                        
                    
                    <div class="clearfix"></div>
                </div>
    
                <ng-container *ngIf="errorMsg.length > 0">
                    <div class="col-12 text-center mt3">
                        <app-validation-input 
                            [text]="error?.msg"
                            *ngFor="let error of errorMsg" 
                            [style]="{
                                margin: '10px 0',
                                color: '#fff',
                                padding: '10px',
                                borderRadius: '5px',
                                background: '#dc3545'
                            }"
                        >
                        </app-validation-input>
                    </div>
                </ng-container>                 

                <div class="wrap_btn text-center">
                    <app-btn 
                        title="دفع"
                        [submit]="true"
                        [disabled]="FormBooking?.invalid || !acceptTerms || isloading"
                    >
                    </app-btn>
                </div>
            </form>
        </div>
    </div>
</div>